<template lang="pug">
v-data-table.elevation-1(:headers='headers' :items='value' sort-by='total')
      template(v-slot:top)
        v-toolbar(flat color='primary' dark)
          v-toolbar-title.justify-center(color='success') Producto
          v-divider.mx-4(inset vertical)
          v-spacer
          v-dialog(v-model='dialog' persistent max-width='70%')
            v-card
              v-card-title
                span.headline {{ formTitle }}
              v-card-text
                v-container
                  v-row
                    v-col(cols='2' sm='6' md='4')
                      v-autocomplete(autocomplete="off" id='auto-hijopedido-producto' dense outlined v-model='editedItem.idProducto' :items='proselec' @change='cambiarProducto' label='Producto')
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model='editedItem.cantidadSolicitada' label='Cantidad')
                  v-row
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model='editedItem.costo'  readonly label='Costo')
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' readonly v-model='editedItem.precio'   label='Precio')
                  v-row
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model="editedItem.subTotal"  readonly label='Total')
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model="editedItem.baseImponible" readonly label='Base Imponible')
                  v-row
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model='editedItem.gravado' readonly label='Gravado')
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined v-model='editedItem.idIva.descripcion' readonly label='IVA (%)')
                  v-row
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model='editedItem.exento' readonly label='exento')
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined v-model='editedItem.porcDescuento' type='number' label='% Descuento')
                  v-row
                    v-col(cols='2' sm='6' md='4')
                      v-text-field(dense outlined type='number' v-model='editedItem.total'  readonly label='Total + IVA')
              v-card-actions
                v-spacer
                v-btn(color='error' small dark @click.native='close')
                  v-icon mdi-close
                  | Cancelar
                v-btn(color='success' small dark @click.native='save')
                  v-icon mdi-content-save
                  | Guardar
      //- template(v-if=" p === 'activar' " v-slot:item.action='{ item }')
      //-   v-icon.mr-2(color='warning' @click='editItem(item)') mdi-pencil
      //-   v-icon(color='error' @click='deleteItem(item)') mdi-delete
      template(v-slot:no-data='')
        h1 No existen productos asociados
</template>

<script>
import Api from '@/services/methods'
export default {
  props: ['value', 'p'], // se lee como value
  data: () => ({
    dialog: false,
    headers: [
      { text: 'Producto', value: 'idProducto.descripcion' },
      { text: 'Cantidad', value: 'despachada' },
      { text: 'Sub Total', value: 'subTotal' },
      // { text: "Gravado", value: "gravado"},
      { text: 'Monto Total', value: 'total' }
    ],
    proselec: '',
    productos: [],
    idProductosArray: [],
    iva: [],
    idIVAArray: [],
    valorIva: 0,
    editedIndex: -1,
    editedItem: {
      idProducto: '',
      cantidadSolicitada: 0,
      precio: 0,
      idIva: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      total: 0,
      baseImponible: 0,
      porcDescuento: 0
    },
    defaultItem: {
      idProducto: '',
      cantidadSolicitada: 0,
      precio: 0,
      idIva: '',
      subTotal: 0,
      gravado: 0,
      exento: 0,
      total: 0,
      baseImponible: 0,
      porcDescuento: 0
    }
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1
        ? 'Ubicacion en almacen'
        : 'Editar ubicacion en almacen'
    }
  },

  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedItem.cantidadSolicitada': function (val) {
      if (parseInt(val) > 0) {
        this.editedItem.subTotal = parseInt(val) * this.editedItem.precio
        this.actualizarPrecios()
      }
    },
    'editedItem.idIva': function (val) {
      if (val !== '') {
        this.editedItem.total = this.editedItem.subTotal + (this.valorIva * this.editedItem.subTotal)
        this.editedItem.gravado = (this.valorIva * this.editedItem.subTotal)
      }
    }
  },
  created () {
    this.initialize()
  },
  methods: {
    initialize () {
      this.listarAlmacenes()
      // this.cargarIVA();
    },
    actualizarPrecios () {
      if (this.editedItem.idIva.valor > 0) {
        // producto con idIva
        this.editedItem.gravado = this.editedItem.subTotal * this.editedItem.idIva.valor
        this.editedItem.exento = 0
        this.editedItem.total = this.editedItem.gravado + this.editedItem.subTotal
        this.editedItem.baseImponible = this.editedItem.subTotal
      } else {
        // producto sin idIva
        this.editedItem.gravado = 0
        this.editedItem.exento = this.editedItem.subTotal
        this.editedItem.total = this.editedItem.exento
        this.editedItem.baseImponible = 0
      }
    },
    listarAlmacenes () {
      Api.get('/proalma/stock/all')
        .then(response => {
          this.productos = response.data
          response.data.map(data => {
            this.idProductosArray.push({
              text: data.idProducto.descripcion,
              value: data.idProducto._id
            })
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar',
             // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message);
          }
        })
    },
    // cargarIVA() {
    //   Api.get("iva")
    //     .then(response => {
    //       this.iva = response.data;
    //       console.log(this.iva);
    //       this.iva.map(data => {
    //         this.idIVAArray.push({
    //           text: data.descripcion,
    //           value: data._id,
    //           valor: data.valor
    //         });
    //       });
    //     })
    //     .catch(e => {
    //       console.log("error" + e);
    //     });
    // },

    // IVASeleccionado(data){
    //   console.log("Seleccionando IVA");
    //   for (let i = 0; i < this.idIVAArray.length; i++) {
    //     if (data == this.idIVAArray[i].value) {
    //       this.editedItem.idIVA = "";
    //       this.editedItem.idIVA = this.idIVAArray[i].value;
    //       this.valorIva = this.idIVAArray[i].valor;
    //     }
    //   }
    // },

    cambiarProducto (data) {
      let proAlma = this.productos.find(proAlma => proAlma.idProducto._id === data)
      this.editedItem.idProducto = proAlma.idProducto
      this.editedItem.precio = proAlma.precio
      this.editedItem.costo = 0
      this.editedItem.idIva = proAlma.idIva
      if (this.editedItem.cantidadSolicitada > 0) { this.actualizarPrecios() }
    },
    validarCampos () {
      if (true) {
        this.$swal({
          icon: 'error',
          title: 'Formulario incompleto',
          text: 'Por favor llene todos los campos para continuar'
        })
        return true
      }
      return false
    },
    editItem (item) {
      this.editedIndex = this.value.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },
    deleteItem (item) {
      const index = this.value.indexOf(item)
      this.$swal({
        icon: 'warning',
        title: '¿Seguro que quieres borrar?',
        text: 'No podras revertir esto',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'cancelar'
      }).then(result => {
        if (result.value) {
          this.$swal('Borrado!', 'Su registro fue borrado.', 'success')
          this.value.splice(index, 1)
        }
      })
    },

    close () {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    save () {
      if (true) {
        if (this.editedIndex > -1) {
          Object.assign(this.value[this.editedIndex], this.editedItem)
        } else {
          //   const almacen = this.idAlmacenArray.find(
          //     almacen => almacen.value == this.editedItem.idAlmacen
          //   );
          //   const descripcion = almacen.text;
          //   const _id = almacen.value;
          //   this.editedItem.idAlmacen = { descripcion, _id };
          this.value.push(this.editedItem)
          this.$emit('input', (this.value = this.value))
        }
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      }
    }
  }
}
</script>
